
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class Pvp extends Vue {
  @Prop() item!: any;

  public data: any = this.item.tabs.pvp.groups;
}
